export type AccountSettingsModalProps = {
  closeModal: () => void;
};

export type formDataType = {
  image: any;
  password: string;
  confirmPassword: string;
};

export const defaultValues = {
  image: '',
  password: '',
  confirmPassword: '',
};
